module.exports = __webpack_public_path__ + "img/Gift_Box_Dark.b77fa07f.png";